<template>
  <Dialog :value="showDialog" @input="$emit('input', $event)" title="ALTERAR DADOS" width="700"
    :show-close-button="true">
    <v-container class="d-flex">
      <m-form ref="formAlterar" @submit.prevent="defenderDados">
        <!-- Exibe esse se for pessoa fisica -->
        <template v-if="isPessoaFisica">
          <v-row>
            <v-col cols="12">
              <p class="mb-6 mt-2 text-subtitle-1">Edite os dados abaixo:</p>
            </v-col>
            <v-col cols="12">
              <v-text-field v-if="consulta.pendencia_nome" id="FieldNome" :name="generateDynamicName('nome')"
                class="required margin-input" v-input-filter="[$filters.text]"
                :rules="[$rules.required, $rules.minThreeLetters]" maxlength="150" v-model="nome_completo" outlined
                autocomplete="disabled" placeholder="Inclua o novo nome" />
            </v-col>
            <v-col cols="12">
              <InputEmail v-if="consulta.pendencia_email" label="" id="FieldEmail" class="required input-email"
                ref="emailField" outlined v-input-filter="[$filters.email]" v-model="email" @input="onEmailInput"
                placeholder="Inclua o novo e-mail" :show-tooltip="false" :rules="[$rules.required, validarEmail]" />

              <transition name="fade-expand" mode="out-in">
                <InputEmail v-if="showEmailConfirmation" id="FieldEmailConfirmation" label=""
                  class="required input-email" ref="emailConfirmationField" outlined v-input-filter="[$filters.email]"
                  v-model="emailConfirmation" :rules="[$rules.required, validarEmail, emailsMatch]"
                  :show-tooltip="false" :prevent-paste="true" placeholder="Confirme o novo email"
                  paste-blocked-message="Por segurança, não é permitido colar o e-mail no campo de confirmação. Digite-o manualmente." />
              </transition>
            </v-col>
            <v-col cols="12">
              <DateField v-if="consulta.pendencia_data_nascimento" id="FieldData" v-model="data_nascimento"
                class="margin-input" :rules="[$rules.required, dataMinima, $rules.dataMaxima150]"
                placeholder="Inclua a nova data de nascimento" />
            </v-col>
          </v-row>
        </template>
        <!-- Exibe esse se for juridica -->
        <v-template v-if="isPessoaJuridica">
          <v-row>
            <v-col cols="6">
              <p class="mb-6 mt-2 text-subtitle-1">Edite os dados abaixo:</p>
            </v-col>
            <v-col cols="12">
              <m-text-field v-if="consulta.pendencia_razao_social" id="FieldRazaoSocial" class="required margin-input"
                v-model="razao_social" v-input-filter="[$filters.textnumeric]" :rules="[$rules.required]" outlined
                @change="validacaoMensagem = true" maxlength="200" :name="generateDynamicName('razao_social')"
                placeholder="Inclua a nova razão social" autocomplete="disabled" />
            </v-col>
            <v-col cols="12">
              <DateField v-if="consulta.pendencia_dt_fundacao" placeholder="Inclua a nova data de fundação"
                id="FieldDataFundacao" class="required margin-input"
                :rules="[$rules.required, $rules.dataMaxima500, $rules.dataPassada]" v-model="data_fundacao"
                autocomplete="disabled" />
            </v-col>
            <v-col cols="12">
              <InputEmail v-if="consulta.pendencia_email" label="" id="FieldEmail" class="required input-email"
                ref="emailField" outlined v-input-filter="[$filters.email]" v-model="email" @input="onEmailInput"
                :show-tooltip="false" placeholder="Inclua o novo e-mail" :rules="[$rules.required, validarEmail]" />
              <transition name="fade-expand" mode="out-in">
                <InputEmail v-if="showEmailConfirmation" label="" id="FieldEmailConfirmation"
                  class="required input-email" ref="emailConfirmationField" outlined v-input-filter="[$filters.email]"
                  v-model="emailConfirmation" :rules="[$rules.required, validarEmail, emailsMatch]"
                  :show-tooltip="false" :prevent-paste="true" placeholder="Confirme o novo email"
                  paste-blocked-message="Por segurança, não é permitido colar o e-mail no campo de confirmação. Digite-o manualmente." />
              </transition>
            </v-col>
          </v-row>
        </v-template>
      </m-form>

      <HintMessage class="mt-8 ml-2" style="max-width: 350px" title="OBSERVAÇÃO" icon="mdi-lightbulb-on-outline"
        icon-color="secondary"
        description='<p>Ao clicar em <strong>“OK”, salvaremos sua alteração</strong>. Para que ela seja <strong>enviada ao Crédito, por favor, clique novamente em “Prosseguir com a Venda”</strong>. Esse processo fará com que os dados sejam <strong>encaminhados novamente para o Motor de Crédito.</strong></p>'
        :description-html="true" :center-icon="false" />
    </v-container>

    <v-layout class="justify-end mb-4">
      <v-btn large id="ButtonAlterar" class="mt-5 btn-alterar" color="primary" @click="alterarDados">
        OK
      </v-btn>
    </v-layout>
  </Dialog>
</template>

<script>
import InputEmail from '@/components/inputs/InputEmail.vue'
import dynamicNameMixin from '@/mixins/dynamicNameMixin'
// import emailMixin from '@/mixins/emailMixin'
import { AlertTypes } from '@/plugins/alerts_types'
import { TipoPessoa } from '@/plugins/constants'
import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
import { notification, unmask } from '@/plugins/helpers'
import { minimumAge } from '@/plugins/validation'
import moment from 'moment'

export default {
  name: 'DialogAlterarDados',
  components: { InputEmail },
  mixins: [dynamicNameMixin],
  props: {
    value: Boolean,
    consulta: { type: Object, required: true },
    tipoPessoa: { type: [String, Number], required: true },
    cliente: { type: Object, required: true }
  },
  data: () => ({
    showEmailConfirmation: false,
    emailConfirmation: '',
    nome_completo: null,
    email: null,
    data_nascimento: '',
    razao_social: null,
    data_fundacao: null,
    configuracao_idade: 16,
    dados_antigos: {},
    dados_novos: {}
  }),
  computed: {
    showDialog: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    },
    isPessoaFisica () {
      return this.tipoPessoa === TipoPessoa.Fisica
    },
    isPessoaJuridica () {
      return this.tipoPessoa === TipoPessoa.Juridica
    }
  },
  watch: {
    showDialog (val) {
      if (val) {
        // Limpa todos os campos ao abrir
        this.nome_completo = ''
        this.email = ''
        this.emailConfirmation = ''
        this.data_nascimento = ''
        this.razao_social = ''
        this.data_fundacao = ''
        this.showEmailConfirmation = false
      }
      if (!val) {
        this.$refs.formAlterar?.resetValidation?.()

        this.nome_completo = ''
        this.email = ''
        this.emailConfirmation = ''
        this.data_nascimento = ''
        this.razao_social = ''
        this.data_fundacao = ''
        this.showEmailConfirmation = false
      }
    }
  },
  methods: {
    preencherDadosAntigos () {
      if (this.isPessoaFisica) {
        this.dados_antigos = {
          nome: this.consulta.nome_completo,
          email: this.consulta.email,
          data_nascimento: this.consulta.data_nascimento
        }
      } else if (this.isPessoaJuridica) {
        this.dados_antigos = {
          razao_social: this.consulta.razao_social,
          email: this.consulta.email,
          data_fundacao: this.consulta.data_fundacao
        }
      }
    },
    preencherDadosNovos () {
      if (this.isPessoaFisica) {
        this.dados_novos = {
          nome: this.nome_completo ? this.nome_completo : this.consulta.nome_completo,
          email: this.email ? this.email : this.consulta.email,
          data_nascimento: this.data_nascimento ? this.data_nascimento : this.consulta.data_nascimento
        }
      } else if (this.isPessoaJuridica) {
        this.dados_novos = {
          razao_social: this.razao_social ? this.razao_social : this.consulta.razao_social,
          email: this.email ? this.email : this.consulta.email,
          data_fundacao: this.data_fundacao ? this.data_fundacao : this.consulta.data_fundacao
        }
      }
    },
    dataMinima (v) {
      let msg_erro = ('A idade minima é ' + this.configuracao_idade + ' anos')
      return (!v || !(v && moment(v, 'DD/MM/YYYY').isAfter(moment(minimumAge(parseInt(this.configuracao_idade))))) || msg_erro)
    },
    onEmailInput () {
      if (this.email && this.email.length > 0) {
        this.showEmailConfirmation = true
      } else {
        this.showEmailConfirmation = false
        this.emailConfirmation = ''
      }
    },
    emailsMatch () {
      return this.email === this.emailConfirmation || 'Os e-mails não correspondem'
    },
    validarEmail (email) {
      const regex = /^[^\s@]+@[^\s@]+$/
      return regex.test(email)
    },
    fechar () {
      this.$refs.formAlterar?.resetValidation?.()
      this.showDialog = false
    },
    async alterarDados () {
      this.preencherDadosAntigos()

      const valid = await this.$refs.formAlterar?.validate?.()
      if (!valid) return

      if (this.showEmailConfirmation && this.emailConfirmation.length > 0 && this.email !== this.emailConfirmation) {
        notification(AlertTypes.WARN, 'Os e-mails não correspondem. Por favor, verifique e tente novamente.')
        return
      }

      const payload = {
        id_consulta: this.consulta.id_consulta,
        id_pedido: this.consulta.id_pedido,
        nome_completo: this.nome_completo,
        email: this.email,
        data_nascimento: this.data_nascimento,
        razao_social: this.razao_social,
        data_fundacao: this.data_fundacao
      }

      this.preencherDadosNovos()

      try {
        await this.$http.post('/alterar-dados/credito-analise', payload)
        sendAnalyticsEvent(this.$gtag, 'alterar_dados_pendentes', {
          id_pedido: this.consulta.id_pedido,
          hierarquia: this.$session.get('hierarquia_comercial'),
          valor_credito: this.consulta.vl_credito,
          bem: this.consulta.nome_bem,
          cliente: {
            cpf_cnpj: this.consulta.pessoa === TipoPessoa.Fisica ? unmask(this.consulta.cpf) : unmask(this.consulta.cnpj)
          },
          dados_antigos: this.dados_antigos,
          dados_novos: this.dados_novos
        })
        notification(AlertTypes.SUCCESS, 'Alterações salvas com sucesso, por favor, prossiga com a venda para enviarmos novamente ao motor de crédito!')
        this.$emit('alteracao-enviada')
        this.fechar()
      } catch (e) {
        notification(AlertTypes.ERROR, 'Erro ao alterar os dados!')
      }
    }
  }
}
</script>

<style scoped>
.margin-input {
  margin-top: -15px !important;
}

.input-email {
  margin-top: -45px !important;
}

.btn-alterar {
  border-radius: 8px !important;
}
</style>
